import AnimationLines from "../../animation/lines/lines";
import {checkDeviceMobile} from "../../../libs/helper";
import barba from "@barba/core";

export class FeatureCaseItem {
    constructor({el, key, onLeave, onHover}) {
        this.DOM = {el};

        this.key = key;
        this.onLeave = onLeave;
        this.onHover = onHover;
        this.timeHover = null;
        this.isDouble = false;
        this.headingAnimation = new AnimationLines(this.DOM.el.querySelector('.js-case_title'), {type: 'mask_bottom'});
        this.bindEvent();
    }

    onMouseEnter() {
        this.timeHover = setTimeout(() => {
            this.enter();
            this.onHover(this.key);
        }, 100);
    }

    onMouseLeave() {
        if (this.timeHover) clearTimeout(this.timeHover);
        this.leave();
        this.onLeave(this.key);
    }

    enter() {
        this.headingAnimation.animationOnlyIn(.3);
        this.DOM.el.classList.add('is-active');
    }

    leave() {
        this.headingAnimation.animationOut(.1);
        this.DOM.el.classList.remove('is-active');
        this.isDouble = false;
    }

    mobileRedirect(event) {

        event.preventDefault();
        event.stopPropagation();

        if (!this.isDouble) {
            this.onMouseEnter();
            this.isDouble = true;
            return;
        }

        this.isDouble = false;
        barba.go(this.DOM.el.getAttribute('href'));
    }

    bindEvent() {
        if (!checkDeviceMobile()) {
            this.DOM.el.addEventListener('mouseenter', this.onMouseEnter.bind(this));
            this.DOM.el.addEventListener('mouseleave', this.onMouseLeave.bind(this));
        } else {
            this.DOM.el.addEventListener('click', this.mobileRedirect.bind(this));
        }
    }

}